import { isShown } from './isShown';
import type { ConditionalLogicHelperOptions } from './types';

export const isNotShown = ({
  questionToCheck,
  questionsToKeep,
}: ConditionalLogicHelperOptions): boolean =>
  !isShown({ questionToCheck, questionsToKeep });
